<div ngbDropdown  class="dropdown">
      <button class="dropdown__btn"
        id="replace-did-provider"
        ngbDropdownToggle>
        <span>{{ value }}</span>
      </button>
      <div ngbDropdownMenu aria-labelledby="replace-did-provider">
        <button ngbDropdownItem
        class="dropdown__item"
        *ngFor="let provider of providers"
      (click)="selectProvider(provider)"
        ><span>{{provider}}</span></button>
      </div>
</div>
